import { BaseApi } from './base.api.js';

export class VulnerabilityApi extends BaseApi {
    constructor(client) {
        super(client, '/vulnerability');
    }
}
